"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CIRValidationUtils = void 0;
var Product_1 = require("../../tasks/coverpath/dependencies/Product");
var ValidationUtils_1 = require("../ValidationUtils");
var nonTableRatedHealthClasses = [
    'ULTRA',
    'SELECT',
    'STANDARD',
    'SELECT_TOBACCO',
    'STANDARD_TOBACCO'
];
var invalidStates = {
    'CA': 'California',
    'NY': 'New York',
    'PR': 'Puerto Rico'
};
var CIRValidationUtils = /** @class */ (function () {
    function CIRValidationUtils() {
    }
    CIRValidationUtils.isValidState = function (state) {
        if (state && Object.keys(invalidStates).includes(state)) {
            return {
                isValid: false,
                message: "CIR is not available for policies in ".concat(invalidStates[state]),
                isGlobalError: true
            };
        }
        return { isValid: true };
    };
    /*
    based on Insured Age
     */
    CIRValidationUtils.isValidCirAge = function (dob) {
        if (ValidationUtils_1.ValidationUtils.isOlderThanAge(dob, Product_1.RiderConstants.cir.maxAge)) {
            return {
                isValid: false,
                message: "CIR is not available for ages over ".concat(Product_1.RiderConstants.cir.maxAge, "."),
                isGlobalError: true
            };
        }
        if (ValidationUtils_1.ValidationUtils.isYoungerThanAge(dob, Product_1.RiderConstants.cir.minAge)) {
            return {
                isValid: false,
                message: "CIR is not available for ages under ".concat(Product_1.RiderConstants.cir.minAge, "."),
                isGlobalError: true
            };
        }
        return { isValid: true };
    };
    CIRValidationUtils.isValidFaceAmount = function (faceAmount) {
        if (faceAmount && faceAmount < Product_1.RiderConstants.cir.minFaceAmount) {
            return {
                isValid: false,
                message: "CIR is not available for policies with a face amount lower than ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.cir.minFaceAmount), "."),
                isGlobalError: true
            };
        }
        return { isValid: true };
    };
    CIRValidationUtils.isValidCirBaseBenefitPool = function (faceAmount, cirAmount) {
        if (cirAmount === null) {
            return { isValid: false, message: "Required", isGlobalError: false };
        }
        if (cirAmount < Product_1.RiderConstants.cir.minBaseBenefitPool) {
            return {
                isValid: false,
                message: "The minimum is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.cir.minBaseBenefitPool), "."),
                isGlobalError: false
            };
        }
        if (cirAmount > Product_1.RiderConstants.cir.maxBaseBenefitPool) {
            return {
                isValid: false,
                message: "The maximum is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.cir.maxBaseBenefitPool), "."),
                isGlobalError: false
            };
        }
        if (faceAmount <= Product_1.RiderConstants.cir.baseFaceAmountForErrorCheck) {
            var max = faceAmount - Product_1.RiderConstants.cir.lowFaceAmountCIRMax;
            if (cirAmount > max) {
                return {
                    isValid: false,
                    message: "The CIR base benefit pool maximum for this policy is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(max), " (it must be at least ").concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(Product_1.RiderConstants.cir.lowFaceAmountCIRMax), " less than the face amount)."),
                    isGlobalError: true
                };
            }
        }
        if (faceAmount >= Product_1.RiderConstants.cir.baseFaceAmountForErrorCheck) {
            var max = Math.floor(faceAmount * Product_1.RiderConstants.cir.highFaceAmountCIRMaxPercent);
            if (cirAmount > max) {
                return {
                    isValid: false,
                    message: "The CIR base benefit pool maximum for this policy is ".concat(ValidationUtils_1.ValidationUtils.formatIntCurrency(max), " (it cannot exceed ").concat(Product_1.RiderConstants.cir.highFaceAmountCIRMaxPercent * 100, "% of the face amount)."),
                    isGlobalError: true
                };
            }
        }
        return { isValid: true };
    };
    CIRValidationUtils.isValidHealthClass = function (healthClass) {
        if (healthClass && !nonTableRatedHealthClasses.includes(healthClass)) {
            return { isValid: false, message: "CIR is not available for policies with a table rating.", isGlobalError: true };
        }
        return { isValid: true };
    };
    CIRValidationUtils.isValidPredictedBenefitAge = function (predictedBenefitAge, dob) {
        if (!predictedBenefitAge) {
            return { isValid: false, message: 'Required' };
        }
        if (predictedBenefitAge > Product_1.RiderConstants.cir.predictedBenefitAgeMaxAge) {
            return { isValid: false, message: "The maximum is ".concat(Product_1.RiderConstants.cir.predictedBenefitAgeMaxAge, ".") };
        }
        var age = Math.floor(ValidationUtils_1.ValidationUtils.getActualAgeInFractionalYears(dob));
        if (age >= predictedBenefitAge) {
            return { isValid: false, message: "This must be at least a year older than insured's age." };
        }
        return { isValid: true };
    };
    CIRValidationUtils.validateCirRider = function (dob, faceAmount, cirAmount, healthClass, predictedBenefitAge, state) {
        var ageValidationResult = this.isValidCirAge(dob);
        var baseBenefitPoolValidationResult = this.isValidCirBaseBenefitPool(faceAmount, cirAmount);
        var healthClassValidationResult = this.isValidHealthClass(healthClass);
        var predictedBenefitAgeResult = this.isValidPredictedBenefitAge(predictedBenefitAge, dob);
        var faceAmountResult = this.isValidFaceAmount(faceAmount);
        var stateResult = this.isValidState(state);
        if (!ageValidationResult.isValid
            || !baseBenefitPoolValidationResult.isValid
            || !healthClassValidationResult.isValid
            || !predictedBenefitAgeResult.isValid
            || !faceAmountResult.isValid
            || !stateResult.isValid) {
            return {
                age: ageValidationResult,
                baseBenefitPool: baseBenefitPoolValidationResult,
                healthClass: healthClassValidationResult,
                predictedBenefitAge: predictedBenefitAgeResult,
                faceAmount: faceAmountResult,
                state: stateResult
            };
        }
        return null;
    };
    return CIRValidationUtils;
}());
exports.CIRValidationUtils = CIRValidationUtils;
